export interface LyricsDB {
  id?: number;
  songID: string;
  lyricsStringifiedOject: string;
}
export const lyricsTable = '++id, songID, lyricsStringifiedOject';

export interface SwipeColorsDB {
  id?: number;
  colorSettingName: string;
  swipeColorStringifiedOject: string;
}

export interface FetchedDataDB {
  id: string;
  url: string;
  data: any;
  timestamp: number;
}

export const swipeColorsTable = '++id, colorSettingName, swipeColorStringifiedOject';

export const fetchedDataTable = '&id, url, data, timestamp';
